import { Component, AfterViewInit } from '@angular/core';
import { DriversListComponent } from "../../tracking/left-track/drivers-list/drivers-list.component"

@Component({
    selector: '[app-drivers-rating]',
    templateUrl: './drivers-rating.component.html',
    styleUrls: ['./drivers-rating.component.css'],
    standalone: false
})
export class DriversRatingComponent extends DriversListComponent implements AfterViewInit
{
  ngAfterViewInit()
  {
    window.dispatchEvent(new CustomEvent("ComponentLoad", { detail: "DriversRating" }));
  }
}
